import { createApi } from '@reduxjs/toolkit/query/react';
import rtkBaseQuery from '../../../utils/rtk-base-query';

export const votingApi = createApi({
  reducerPath: 'votingApi',
  baseQuery: rtkBaseQuery({ baseUrl: '/api/v2' }),
  endpoints: (builder) => ({
    getVotingAgainstManagement: builder.query({
      query: () => ({ url: '/company/voting-against-management' }),
    }),
  }),
});

export const { useLazyGetVotingAgainstManagementQuery } = votingApi;
